import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { HubHeader } from '@/components/layout/hub-header'
import { HubSidebar } from '@/components/layout/hub-sidebar'
import { ErrorBoundaryClass } from '@/components/ErrorBoundary'

export function HubLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <div className="flex h-screen overflow-hidden">
      <HubSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex flex-1 flex-col overflow-hidden">
        <HubHeader onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        <main className="flex-1 overflow-y-auto">
          <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
            <ErrorBoundaryClass level="hub">
              <Outlet />
            </ErrorBoundaryClass>
          </div>
        </main>
      </div>
    </div>
  )
}
